import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic'
import contact from './contact';
import landing from './templateLandingPage';

export default {
  init() {
    contact.handleContactForm();
    landing.parallaxImage();
    landing.slider();
    landing.appendUTMQueryParamsToCtas();
    landing.playVideoOnScroll();
    this.scrollToForm();
    this.automaticBenefitsCycle();
    this.pinSidebarBenefits();
  },
  automaticBenefitsCycle() {
    setInterval(function () {
      const benefits = $('#benefitsListing .single-benefit')
      if (benefits.length) {
        const active = $(benefits).filter('.active')
        const next = ($(active).next().length) ? $(active).next() : $(benefits)[0]
        $(benefits).removeClass('active');
        $(next).addClass('active')
      }
    }, 4000)
  },
  scrollToForm() {
    $('#scroll-to').click(function (e) {
      e.preventDefault();
      var target = $(this).attr('data-target');
      $('html, body').animate({ scrollTop:  $(target).offset().top  - 100});
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  pinSidebarBenefits() {

      const controller = new ScrollMagic.Controller();

      var containerHeight = 0;

      function getContainerHeight() {
        return containerHeight;
      }

      $(window).scroll(function() {
        containerHeight = ($('#mainContainer').outerHeight() - $('#benefitsListing').outerHeight())- 40;
      });

      new ScrollMagic.Scene({
        triggerElement: '#benefitsListing',
        duration: getContainerHeight,
        triggerHook: 0.17,
      })
        .setPin('#benefitsListing', {pushFollowers: false})
        .addTo(controller);
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js